<template>
  <nav
    v-if="hasItems"
    class="w-full min-w-0 overflow-x-auto text-sm font-medium"
    aria-label="breadcrumb"
    dusk="breadcrumbs"
  >
    <ol class="flex w-max min-w-full flex-nowrap items-center whitespace-nowrap">
      <li
        v-for="(item, index) in breadcrumbs"
        class="inline-flex shrink-0"
        v-bind="{
          'aria-current': isActive(index) ? 'page' : null,
        }"
      >
        <div class="flex items-center">
          <Link
            v-if="item.path !== null"
            :href="$url(item.path)"
            class="no-underline"
            :class="
              isActive(index)
                ? 'font-semibold text-primary-500 dark:text-primary-400'
                : 'text-zinc-600 transition hover:text-zinc-900 dark:text-white dark:hover:text-white/80'
            "
          >
            {{ item.name }}
          </Link>
          <span
            v-else
            :class="
              isActive(index)
                ? 'font-semibold text-primary-500 dark:text-primary-400'
                : 'text-zinc-600 dark:text-white'
            "
          >
            {{ item.name }}
          </span>
          <Icon
            :type="isRTL ? 'chevron-left' : 'chevron-right'"
            v-if="index < breadcrumbs.length - 1"
            class="mx-2 h-4 w-4 text-zinc-300 dark:text-zinc-600"
          />
        </div>
      </li>
    </ol>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  methods: {
    isActive(index) {
      return index === this.breadcrumbs.length - 1
    },
  },

  computed: {
    ...mapGetters(['breadcrumbs']),

    hasItems() {
      return this.breadcrumbs.length > 0
    },
    isRTL() {
      return Nova.config('rtlEnabled')
    },
  },
}
</script>

<style scoped>
nav::-webkit-scrollbar {
  display: none;
}

nav {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
